<template>
  <div>
    <div class="row">
      <div class="col-sm-7">
        <a @click="openAddModal()" class="btn-primary"><i class="fas fa-plus-square mr-5"></i>Add</a>
      </div>
    </div>
    <hr class="mb-0 mt-15">
    <div class="pt-15">
      <b-table :hover="true" :striped="true" responsive="sm" :items="items" :fields="fields" :current-page="currentPage">
        <template v-slot:cell(branch)="data">
          <span>{{ data.item.branch ? data.item.branch.name : 'Semua Branch' }}</span>
        </template>
        <template v-slot:cell(employee)="data">
          <span>{{ data.item.employee ? data.item.employee.name : '-' }}</span>
        </template>
        <template v-slot:cell(actions)="data">
          <b-button size="sm" @click="openEditModal(data.item)" class="btn-table warning mr-1">
            <i class="far fa-edit"></i> Edit
          </b-button>
          <b-button size="sm" @click="deleteItem(data.item.id)" class="btn-table danger">
            <i class="fas fa-times"></i> Delete
          </b-button>
        </template>
      </b-table>
      <app-pagination class="pagination-custom mt-20" :current-page="currentPage" :total-pages="totalPage"
        @page-changed="pageOneChanged" prev-text="Prev" next-text="Next" />
    </div>

    <b-modal ref="assigneeModal" hide-footer centered :title="editingId ? 'Edit Inventory Approval' : 'Add Inventory Approval'">
      <div class="p-10">
        <b-row class="mb-20">
          <b-col sm="3"><label>Branch</label></b-col>
          <b-col sm="9">
            <b-form-select v-model="formData.branch_id">
              <option :value="null">Semua Branch</option>
              <option v-for="item in dataBranch" :key="item.id" :value="item.id">{{ item.name }}</option>
            </b-form-select>
          </b-col>
        </b-row>
        <b-row class="mb-20">
          <b-col sm="3"><label>Employee</label></b-col>
          <b-col sm="9">
            <input type="text" class="form-control" v-model="employeeKeyword" @input="onEmployeeKeywordChange"
              placeholder="Cari nama employee...">
            <div v-if="employeeOptions.length" class="employee-options">
              <div v-for="opt in employeeOptions" :key="opt.id" class="employee-option" @click="selectEmployee(opt)">
                {{ opt.name }} <small class="text-muted">({{ opt.branch_name || '-' }})</small>
              </div>
            </div>
            <div v-if="selectedEmployeeName" class="mt-10">
              <b-badge variant="info">{{ selectedEmployeeName }}</b-badge>
            </div>
            <span class="error">{{ formError }}</span>
          </b-col>
        </b-row>
        <div class="text-right mt-20">
          <button class="btn-primary" @click="submitForm">Submit</button>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import axios from 'axios'
import { Auth } from '@/api'
import Pagination from '@/views/component/pagination'

export default {
  name: 'inventoryApprovalAssignees',
  components: {
    'app-pagination': Pagination
  },
  data: () => {
    return {
      fields: [
        { key: 'branch', label: 'Branch' },
        { key: 'employee', label: 'Employee' },
        { key: 'actions', label: 'Actions' }
      ],
      items: [],
      dataBranch: [],
      currentPage: 1,
      paginationLimit: 10,
      totalPage: 0,
      editingId: null,
      formData: { branch_id: null, employee_id: null },
      employeeKeyword: '',
      employeeOptions: [],
      selectedEmployeeName: '',
      employeeSearchTimer: null,
      formError: ''
    }
  },
  methods: {
    pageOneChanged(pageNum) {
      this.currentPage = pageNum
      this.fetchData()
    },
    fetchData() {
      axios.defaults.headers.common['X-Access-Token'] = Auth.Session.get().paradigm_token
      axios.get('crm/v1/inventory_approval_assignees?page=' + this.currentPage + '&limit=' + this.paginationLimit).then(response => {
        this.items = response.data.data.rows
        this.totalPage = response.data.meta.pageCount
      }).catch(error => {
        console.log('error', error)
      })
    },
    fetchBranch() {
      // Sengaja pakai daftar branch dari crm/v1/inventory_approval_assignees/branches
      // (langsung dari tabel `branch`, sama seperti yang dipakai Inventory
      // App sendiri), BUKAN fitness/v1/branch/ - dikonfirmasi ke user,
      // fitness/v1/branch/ exclude HO, di sini harus lengkap termasuk HO.
      axios.get('crm/v1/inventory_approval_assignees/branches').then(response => {
        this.dataBranch = response.data.data
      }).catch(error => {
        console.log('error', error)
      })
    },
    openAddModal() {
      this.editingId = null
      this.formData = { branch_id: null, employee_id: null }
      this.employeeKeyword = ''
      this.employeeOptions = []
      this.selectedEmployeeName = ''
      this.formError = ''
      this.$refs.assigneeModal.show()
    },
    openEditModal(item) {
      this.editingId = item.id
      this.formData = { branch_id: item.branch_id, employee_id: item.employee_id }
      this.employeeKeyword = ''
      this.employeeOptions = []
      this.selectedEmployeeName = item.employee ? item.employee.name : ''
      this.formError = ''
      this.$refs.assigneeModal.show()
    },
    onEmployeeKeywordChange() {
      clearTimeout(this.employeeSearchTimer)
      this.employeeSearchTimer = setTimeout(() => {
        if (!this.employeeKeyword) {
          this.employeeOptions = []
          return
        }
        axios.get('crm/v1/inventory_approval_assignees/employees?keyword=' + this.employeeKeyword).then(response => {
          this.employeeOptions = response.data.data
        }).catch(error => {
          console.log('error', error)
        })
      }, 300)
    },
    selectEmployee(opt) {
      this.formData.employee_id = opt.id
      this.selectedEmployeeName = opt.name + ' (' + (opt.branch_name || '-') + ')'
      this.employeeOptions = []
      this.employeeKeyword = ''
    },
    submitForm() {
      if (!this.formData.employee_id) {
        this.formError = 'Employee wajib dipilih'
        return
      }
      this.formError = ''
      axios.defaults.headers.common['X-Access-Token'] = Auth.Session.get().paradigm_token

      const request = this.editingId
        ? axios.put('crm/v1/inventory_approval_assignees/' + this.editingId, this.formData)
        : axios.post('crm/v1/inventory_approval_assignees/', this.formData)

      request.then(() => {
        this.$refs.assigneeModal.hide()
        this.fetchData()
        this.$toast.success('data saved successfully!', 'Success', {
          position: 'topCenter',
          icon: 'icon-envelope',
          progressBarColor: 'rgb(0, 255, 184)',
          theme: 'dark',
          backgroundColor: '#565c70',
          messageColor: '#fff'
        })
      }).catch(error => {
        this.formError = error.response && error.response.data && error.response.data.message
          ? error.response.data.message : 'Gagal menyimpan data'
      })
    },
    deleteItem(id) {
      this.$swal({
        title: 'Are you sure?',
        text: 'You can\'t revert your action',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes Delete it!',
        cancelButtonText: 'No, Keep it!',
        showCloseButton: true,
        showLoaderOnConfirm: false
      }).then((result) => {
        if (result.value) {
          axios.defaults.headers.common['X-Access-Token'] = Auth.Session.get().paradigm_token
          axios.delete('crm/v1/inventory_approval_assignees/' + id).then(() => {
            this.$swal('Deleted', 'You successfully deleted this data', 'success')
            this.fetchData()
          }).catch(error => {
            console.log('error', error)
          })
        } else {
          this.$swal('Cancelled', 'Your data is still intact', 'info')
        }
      })
    }
  },
  created() {
    this.fetchData()
    this.fetchBranch()
  }
}
</script>

<style scoped>
.employee-options {
  border: 1px solid #ddd;
  border-radius: 4px;
  margin-top: 4px;
  max-height: 180px;
  overflow-y: auto;
}

.employee-option {
  padding: 6px 10px;
  cursor: pointer;
}

.employee-option:hover {
  background: #f5f5f5;
}
</style>
